import { DEFAULT_CURRENCY, resolveCurrencyCode } from "@/lib/utils/currency";
import { useTenantData } from "./useTenantData";

/** Tenant currency from account settings, falling back to USD when unset. */
export function useTenantCurrency(): string {
  const { tenantData } = useTenantData();
  return resolveCurrencyCode(tenantData?.currency ?? DEFAULT_CURRENCY);
}
